import { http } from '../api/http';

export type DevelopmentImage = {
  id: number;
  image_url: string;
  alt?: string | null;
  caption?: string | null;
  sort_order: number;
  is_cover: boolean;
};

export const DevelopmentImagesService = {
  create(developmentId: number | string, payload: { image_url: string; is_cover?: boolean; sort_order?: number }) {
    return http<{ ok: boolean; data?: any }>(`/admin/developments/${developmentId}/images`, {
      method: 'POST',
      body: payload
    });
  },

  reorder(developmentId: number | string, payload: { ids: number[]; coverId?: number }) {
    return http<{ ok: boolean; data?: any }>(`/admin/developments/${developmentId}/images/reorder`, {
      method: 'POST',
      body: {
        ids: payload.ids.map(String),
        coverId: payload.coverId != null ? String(payload.coverId) : undefined
      }
    });
  },

  remove(developmentId: number | string, imageId: number | string) {
    return http<{ ok: boolean }>(`/admin/developments/${developmentId}/images/${imageId}`, {
      method: 'DELETE'
    });
  }
};
